<div class="pv">
  <div class="pv__bar">
    <p class="bk-eyebrow">{{ heading }}</p>
    @if (total()) {
      <div class="pv__nav">
        <button
          type="button"
          class="bk-icon-btn"
          aria-label="Previous row"
          matTooltip="Previous row"
          [disabled]="index() === 0"
          (click)="step(-1)"
        >
          <span class="bk-sym" aria-hidden="true">chevron_left</span>
        </button>
        <span class="pv__pos" aria-live="polite">
          Row {{ formatCount(index() + 1) }} of {{ formatCount(total()) }}
        </span>
        <button
          type="button"
          class="bk-icon-btn"
          aria-label="Next row"
          matTooltip="Next row"
          [disabled]="index() >= total() - 1"
          (click)="step(1)"
        >
          <span class="bk-sym" aria-hidden="true">chevron_right</span>
        </button>
      </div>
    }
  </div>

  @if (total()) {
    <form class="pv__find" role="search" (submit)="find($event)">
      <span class="bk-sym pv__find-icon" aria-hidden="true">search</span>
      <input
        class="pv__input"
        type="search"
        placeholder="Find a row by number or name"
        aria-label="Find a row by number or name"
        [value]="query()"
        (input)="onQuery($event)"
      />
      <button type="submit" class="bk-icon-btn pv__find-go" aria-label="Find next match" matTooltip="Find next match">
        <span class="bk-sym" aria-hidden="true">arrow_downward</span>
      </button>
    </form>
    <!-- Always in the page, so screen readers hear a search that finds nothing. -->
    <p class="bk-sr-only" role="status" aria-live="polite">
      {{ searchMiss() ? "No row contains “" + query() + "”." : "" }}
    </p>
    @if (searchMiss()) {
      <p class="pv__miss" aria-hidden="true">No row contains “{{ query() }}”.</p>
    }

    <div class="pv__who">
      <app-status [text]="status().text" [status]="status().tone" />
      <span class="pv__facts">
        <span class="pv__number">{{ numberLabel() }}</span>
        <span class="pv__sep" aria-hidden="true">·</span>
        <span>Sheet row {{ sheetRow() }}</span>
      </span>
    </div>
  }

  <!-- The row's message as it lands on the person's phone. -->
  <bk-iphone-preview
    [senderId]="store.senderIdSig()"
    [text]="rendered().text"
    [exact]="true"
    [emptyText]="emptyText()"
  />

  @if (hasBody() && total()) {
    <!-- Exact for this row, {{fields}} left as written included. -->
    <p class="pv__length">
      {{ lengthLabel() }}<span class="pv__sep" aria-hidden="true">·</span>{{ partsLabel() }}
      @if (encodingLabel()) {
        <span class="pv__sep" aria-hidden="true">·</span>{{ encodingLabel() }}
      }
    </p>
    @if (literal().length) {
      <p class="pv__literal">
        <span class="bk-sym" aria-hidden="true">info</span>
        <span>
          This row is sent with {{ literalLabel() }} as written, because
          {{ literal().length === 1 ? "that value is" : "those values are" }} missing.
        </span>
      </p>
    }
  }

  @if (checkRows().length || testable) {
    <div class="pv__actions">
      @if (checkRows().length) {
        <button type="button" class="bk-more" (click)="nextToCheck()">
          Next row to check
          <span class="bk-sym" aria-hidden="true">arrow_forward</span>
        </button>
      }
      @if (testable) {
        <button
          type="button"
          class="bk-btn bk-btn--ghost pv__test"
          [attr.aria-disabled]="!canTest() || null"
          [attr.aria-describedby]="!canTest() && hasBody() ? 'sb-test-hint' : null"
          (click)="openTest()"
        >
          <span class="bk-sym" aria-hidden="true">send_to_mobile</span>
          Send this row as a test
        </button>
      }
    </div>
    @if (testable && !canTest() && hasBody()) {
      <p class="pv__hint" id="sb-test-hint">Choose a sender ID to send a test.</p>
    }
  }
</div>

@if (testable) {
  <app-send-test-message-modal
    [openModal]="testOpen"
    [messageBody]="rendered().text"
    [senderId]="store.senderIdSig()"
    (closeModalEvent)="testOpen = false"
  />
}
